import React from 'react'
import { intlShape } from 'react-intl'
import logo from '../../resources/img/logo-qobuz-large.png'
import GTMController from "../../utils/kpi/GTMController"

const HeaderMenu =  (props, context) => {
	const { intl } = context

	return (
		<div className="header">
			<div className="header__container">
				<a className="header__brand" href={`https://www.qobuz.com/${location.search}`} onClick={() => { GTMController.pushLogoClickedEvent()}}>
					<img className="header__logo" alt="logo" src={logo} />
				</a>
				<a
					className="header__button"
					href={`https://www.qobuz.com/store-router/music/streaming/offers${location.search}`}
					target="_blank"
					onClick={() => { GTMController.pushTryQobuzEvent()}}
				>
					{intl.formatMessage({ id: 'buttons.download' })}
				</a>
			</div>
		</div>
	)
}

HeaderMenu.propTypes = {}

HeaderMenu.contextTypes = {
	intl: intlShape
}

export default HeaderMenu



// WEBPACK FOOTER //
// ./src/components/header/HeaderMenu.js